<script lang="ts" setup>
const props = defineProps<{
  label?: string
}>()

const isServiceAvailabilityLabel = computed(() => props.label?.includes('Stunden verfügbar'))
const isServiceAvailabilityLabelWithNoFreeSlots = computed(() => props.label?.includes('Keine Termine in den nächsten'))
</script>

<template>
  <IaBadge class="ia-block !bg-primaryBeige-50">
    <slot>
      <span
        class="text-grey-600 font-400"
      >
        {{ label }}
      </span>
    </slot>
    <template #after>
      <i
        v-if="isServiceAvailabilityLabelWithNoFreeSlots"
        i-fad:triangle-exclamation
        text-warning-500
      ></i>
      <i
        v-else-if="isServiceAvailabilityLabel"
        i-fas:circle
        text-success-300
      ></i>
      <i
        v-else
        i-fas:check
        text-success-300
      ></i>
    </template>
  </IaBadge>
</template>
